import { Button, FormControlLabel, Switch, TextField } from '@material-ui/core';
import { green, red } from '@material-ui/core/colors';
import { withStyles } from '@material-ui/core/styles';
import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { userCanUseTPO } from '../../../utils/RolesBasedUsers';

import Api from '../../../api/api';
import InsufficientPermission from '../InsufficientPermission';

const CustomSwitch = withStyles({
  switchBase: {
    color: red[500],
    '&$checked': {
      color: green[500],
    },
    '&$checked + $track': {
      backgroundColor: green[500],
    },
  },
  checked: {},
  track: {},
})(Switch);

const EditPaymentDetails = ({ dealer, onSuccess }) => {
  const [pixelEnabled, setPixelEnabled] = useState(dealer.isPixelEnabled);
  const [pixelId, setPixelId] = useState(dealer.pixelId);
  const [osbConnectId, setOsbConnectId] = useState(dealer.osbStripeConnectId);
  const [changeReason, setChangeReason] = useState('');

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  /**
   * This strips out everything past 2 decimals points
   * @param {string} value string version of a number
   */
  const setToMaxTwoDecimalPoints = value => Math.floor(value * 100) / 100;
  const setDiscountPercent = value => {
    if (Number(value) !== NaN && value >= 0) {
      const num = Number(value);
      _setDiscountPercent(Math.floor(num));
    } else _setDiscountPercent(0);
  };

  const setMaxDiscount = value => {
    if (Number(value) !== NaN && value >= 0) {
      const num = Number(value);
      const _value = Number.isInteger(num) ? value : setToMaxTwoDecimalPoints(value);
      _setMaxDiscount(_value);
    } else _setMaxDiscount(0);
  };

  const submit = async () => {
    let _errorMessage = '';
    if (!changeReason) _errorMessage += 'Please provide a change reason';
    if (pixelEnabled && !pixelId) {
      _errorMessage += 'Pixel ID cannot be empty when Enable Pixel is selected.\n';
    }

    setErrorMessage(_errorMessage);
    if (_errorMessage) {
      return;
    }
    const payload = {
      //featureToggleDtoRequest passed to support basic validation on the api side
      featureToggleDtoRequest: [],
      reason: changeReason,
      dealerCode: dealer.dealerCode,
      locationCode: dealer.locationCode,
      isPixelEnabled: pixelEnabled,
      pixelId: pixelId,
      osbStripeConnectId: osbConnectId,
      tab: 'tpo',
    };
    
    // set featureToggleDtoRequest to the unmodified version so no accidental saving of unintentional data
    dealer.features.map(feature => {
      payload.featureToggleDtoRequest.push({
        dmsName: dealer.dmsName,
        featureName: feature.feature,
        isEnabled: feature.value,
        serviceSiteId: dealer.serviceSiteId,
      });
    });
    try {
      setLoading(true);
      const result = await Api.updateDealer(payload);
      if (result.includes('No Database Changes')) {
        setErrorMessage(result);
      } else {
        onSuccess();
      }
    } catch (error) {
      let _error = '';

      if (error.response && error.response.status !== 200) {
        _error = `Status Code ${error.response.status}: ${error.response.statusText}`;
      }
      if (error.response && error.response.data && error.response.data.errors) {
        _error += `\n Error Message: ${error.response.data.errors[0]}`;
      }

      setErrorMessage(_error);
    } finally {
      setLoading(false);
    }
  };

  return !userCanUseTPO() ? (
    <InsufficientPermission />
  ) : (
    <Row id="userHasRoleAssigned" style={{ marginTop: '15px' }} >
      <Col xs={12} md={8}>
        <Row>
          <Col xs={12} md={4} style={{ marginTop: '10px' }}>
            Enable Pixel:
          </Col>
          <Col xs={12} md={8}>
            <FormControlLabel
              control={
                <CustomSwitch
                onChange={() => setPixelEnabled(!pixelEnabled)}
                  checked={pixelEnabled}
                  id={'pixelEnabled'}
                  size="medium"
                />
              }
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={4}  style={{ marginTop: '15px' }}>
            Pixel ID:
          </Col>
          <Col xs={12} md={8}>
            <FormControlLabel
              control={
                <TextField
                  id="pixelId"
                  value={pixelId}
                  onChange={event => setPixelId(event.target.value)}
                  variant="outlined"
                  placeholder="Pixel ID"
                />
              }
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={4} style={{ marginTop: '5px' }}>
            OSB Stripe Connect ID:
          </Col>
          <Col xs={12} md={8}>
            <FormControlLabel
              control={
                <TextField
                  id="osbConnectId"
                  value={osbConnectId}
                  onChange={event => setOsbConnectId(event.target.value)}
                  variant="outlined"
                  placeholder="OSB Connect ID"
                />
              }
            />
          </Col>
        </Row>        
      </Col>
      <Col xs={12} md={4}>
        <Row>
          <Col>
            <strong>CHANGE REASON</strong>
          </Col>
        </Row>

        <Row>
          <Col>
            <FormControlLabel
              control={
                <TextField
                  id="changeReason"
                  value={changeReason}
                  onChange={event => setChangeReason(event.target.value)}
                  variant="outlined"
                  placeholder="Change Reason"
                />
              }
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <Button
              color="primary"
              variant="contained"
              disabled={!changeReason && !loading}
              size="large"
              onClick={() => submit()}
            >
              {loading ? 'Loading..' : 'SAVE & UPDATE'}
            </Button>
          </Col>
        </Row>
        <Row>
          <Col>
            <p className="error">{errorMessage}</p>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default EditPaymentDetails;



// WEBPACK FOOTER //
// ./src/components/Dealers/EditPaymentDetails/EditPaymentDetails.js